import React from "react";
import Aside from "./aside";
import { Outlet, Route, Routes, useNavigate } from "react-router";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import useDeviceType from "../../hook/useDeviceType";
import SimpleRewards from "../Rewards/simpleRewards";
import SimpleReferCode from "../ReferCode/simpleReferCode";
import { common_route } from "../../utils/routes";

const SettingIndex = ({ children, showAside }) => {
  const previousPage = usePreviousPagePath();

  const deviceType = useDeviceType();

  const navigate = useNavigate();

  return (
    <main
      // onClick={() => navigate("../")}
      className="fixed top-0 left-0 w-full h-full z-[9999] box-shadow bg-[rgb(0,0,0,0.7)] flex items-center justify-center md:px-common-padding-x"
    >
      <section
        onClick={(e) => e.stopPropagation()}
        className="md:w-[630px] md:min-h-[710px] md:max-h-[600px] h-full w-full bg-base-white dark:bg-base-deep-black md:rounded-[15px] overflow-hidden flex justify-between"
      >
        {/* {deviceType === "Mobile" && showAside ? null : (
          <aside className="md:w-[225px] w-full py-[15px] px-[10px]">
            <Aside />
          </aside>
        )}
        {deviceType === "PC" || deviceType === "Mobile" ? (
          <main className="md:w-[375px] w-full overflow-y-scroll overflow-x-hidden no-scrollbar">
            {children}
          </main>
        ) : null} */}
        <aside className="md:w-[225px] w-full md:py-[15px] py-[10px] px-[10px]">
          <Aside />
        </aside>
        <main className="md:w-[375px] relative overflow-x-hidden no-scrollbar flex flex-col">
          <Routes>
            {common_route
              .filter((route) => route.profile)
              .map((route) => {
                return (
                  <Route
                    path={route.path}
                    element={
                      <>
                        {route.element}
                        <Outlet />
                      </>
                    }
                  >
                    {route.children?.map((item) => {
                      return (
                        <Route
                          key={item.label}
                          path={`${item.path}`}
                          element={
                            <>
                              {item.element}
                              <Outlet />
                            </>
                          }
                        />
                      );
                    })}
                  </Route>
                );
              })}
          </Routes>
        </main>
      </section>
    </main>
  );
};

export default SettingIndex;
